<template>
  <BaseScreen v-bind="screen">
    <BaseAlert
      v-if="isErrorVisible"
      v-bind="error"
      slot="middle"
    />
    <MyBalance
      v-bind="balance"
      @pay="goToConfirmScreen"
    />
  </BaseScreen>
</template>

<script>
import {
  mapState, mapGetters, mapMutations, mapActions,
} from 'vuex';
import CONSTANTS from '@/helpers/constants';

import screenMixin from '@/mixins/screen';

import MyBalance from '@/components/MyBalance.vue';

export default {
  name: 'GuestBalanceScreen',
  mixins: [screenMixin],
  components: {
    MyBalance,
  },
  computed: {
    ...mapState('payment', [
      'account',
      'charges',
    ]),
    ...mapGetters('payment', [
      'sum',
      'diffSum',
    ]),
    titleText() {
      return !this.account ? '' : this.$t('titles.accountPay', {
        account: this.account.code,
      });
    },
    screenCase() {
      if (this.isErrorVisible) {
        return CONSTANTS.STEP_CONNECTION_ERROR;
      }
      if (this.account) {
        return CONSTANTS.STEP_ORDER;
      }
      return null;
    },
    balance() {
      return {
        charges: this.charges,
        sum: this.sum,
        diffSum: this.diffSum,
        currentAccount: this.account,
        isSideVisible: false,
      };
    },
    retryAction() {
      return this.fetchAccount;
    },
    error() {
      return {
        icon: {
          name: 'important',
          theme: 'secondary',
          size: 'l',
        },
        title: {
          text: this.$t('titles.badConnection'),
          size: 'l',
        },
        description: {
          text: this.$t('texts.badConnection'),
          size: 'l',
        },
        actions: [
          {
            text: this.$t('actions.home'),
            action: this.goToHomeScreen,
            view: 'outlined',
          },
          {
            text: this.$t('actions.retry'),
            action: this.retryErrorAction,
          },
        ],
      };
    },
  },
  created() {
    this.initActions([
      [CONSTANTS.ACTION_PAY, this.goToConfirmScreen],
    ]);
    this.fetchCharges();
  },
  methods: {
    ...mapMutations('payment', [
      'setAccount',
      'setCharges',
    ]),
    ...mapActions('payment', [
      'getChargesByAccountCode',
    ]),
    async fetchCharges() {
      try {
        this.showPending(0);
        const { account, charges } = await this.getChargesByAccountCode(this.$route.query.account);
        this.setAccount(account);
        this.setCharges(charges);
        this.hidePending();
      } catch (e) {
        console.error('fetchCharges', e);
        this.showError();
      }
    },
    goToConfirmScreen() {
      return this.$router.push(this.$router.options.paths.confirm);
    },
  },
};
</script>
